import {Component, EventEmitter, Injector, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {BaseComponent} from '../../base.component';
import {ListResponse} from '../../../network/service/list.response';
import {SnackBarUtil} from '../../../util/snack.bar.util';
import {StringUtil} from '../../../util/string.util';
import {RequestType} from '../../../enums/request.type';
import {DataResponse} from '../../../network/service/data.response';
import {ChooserOptions} from '../dialog/chooser/options/chooser.options';
import {ChooserComponent} from '../dialog/chooser/chooser.component';
import {Config} from '../../../common/config';
import {RouteUtil} from '../../../util/route.util';
import {SessionStorageUtil} from '../../../util/session.storage.util';
import {strings} from '../../../../value/strings';

@Component({
  selector: 'app-check-out',
  standalone: false,
  templateUrl: './check-out.component.html',
  styleUrl: './check-out.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class CheckOutComponent extends BaseComponent implements OnInit {
  paymentMethods?: any[];
  deliveryMethods?: any[];
  selectedUserAddress?: any;
  selectedDeliveryMethod?: any;
  selectedPaymentType?: any;
  selectedSpace?: any;
  userAddresses?: any[];
  preFactor?: any;
  delivery?: any;
  @Output() onDataSubmitted = new EventEmitter<any>();
  protected readonly StringUtil = StringUtil;
  protected readonly Config = Config;

  constructor(injector: Injector) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override loadOnline() {
    super.loadOnline();
    this.serviceApi.getDeliveryMethods(undefined, undefined, undefined, RequestType.ALL, {
      Filter: {},
      Order: {
        Field: 'Title',
        Type: 'ASC'
      }
    }, Config.branch.BusinessId).subscribe((res: ListResponse<any>) => {
      if (res.success) {
        this.deliveryMethods = res.data;
        if (SessionStorageUtil.loadInt(strings.customer_space_id, 0) !== 0) {
          this.serviceApi.getSpaces(undefined, undefined, undefined, RequestType.ONE, undefined, {
            Filter: {
              Values: [{
                Field: 'SpaceId',
                Type: 'EQ',
                Value: SessionStorageUtil.loadInt(strings.customer_space_id, 0)
              }]
            },
            Order: {}
          }).subscribe((res: ListResponse<any>) => {
            if (res.success) {
              this.selectedSpace = res.data;
              this.onChangeDeliveryMethod(this.deliveryMethods?.find((deliveryMethod: any) => deliveryMethod.Type === 'INSIDE'));
            } else {
              SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
            }
          });
        } else {
          if ((this.deliveryMethods ?? []).length > 0) {
            this.onChangeDeliveryMethod(this.deliveryMethods![0]);
          }
        }
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  getPreFactor(deliveryMethodeId?: any) {
    this.serviceApi.getPreFactor({
      DeliveryMethodId: deliveryMethodeId
    }).subscribe((res: ListResponse<any>) => {
      if (res.success) {
        this.preFactor = res.data;
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  changePaymentMethod(deliveryMethod?: any) {
    this.serviceApi.getPaymentMethode(undefined, undefined, undefined, RequestType.ALL, {
      Filter: {
        Type: "AND",
        Values: [{
          Field: "IncludePaymentMethodIds",
          Type: "IN",
          Value: deliveryMethod.PaymentMethodIds
        }]
      },
      Order: {
        Field: 'Title',
        Type: 'ASC'
      }
    }, Config.branch.BusinessId).subscribe((res: ListResponse<any>) => {
      if (res.success) {
        this.paymentMethods = res.data;
        if (this.paymentMethods!.length > 0) {
          this.selectedPaymentType = this.paymentMethods![0];
        }
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  onChangeDeliveryMethod(deliveryMethod: any) {
    this.selectedDeliveryMethod = deliveryMethod;
    if (deliveryMethod.Type === 'OUTSIDE_DELIVER') {
      this.serviceApi.getUserAddresses(0, 0, '', 'ONE', {
        Filter: {
          Values: [{
            Field: 'DeliveryMethodId',
            Type: 'EQ',
            Value: this.selectedDeliveryMethod.DeliveryMethodId
          }, {
            Field: 'UserId',
            Type: 'EQ',
            Value: this.Config.userInformation.UserId
          }]
        },
        Order: {
          Field: 'Title',
          Type: 'ASC'
        }
      }).subscribe((res: DataResponse<any>) => {
        if (res.success) {
          this.selectedUserAddress = res.data;
        }
      });
    }
    if (deliveryMethod.Type !== 'OUTSIDE_DELIVER') {
      this.selectedUserAddress = undefined;
    }
    this.getPreFactor(this.selectedDeliveryMethod.DeliveryMethodId);
    this.changePaymentMethod(this.selectedDeliveryMethod);
  }

  onChangePaymentMethod(paymentMethod: any) {
    this.selectedPaymentType = paymentMethod;
  }

  openChangeAddressClicked() {
    if (this.hasAccount()) {
      let chooserOptions = new ChooserOptions();
      const previousAddress = this.selectedUserAddress;
      let chooseAddressComponent = this.matDialog.open(ChooserComponent, {
        width: '1284px',
        height: '60%',
        data: {
          chooserType: 'USER_ADDRESS',
          UserId: this.Config.userInformation.UserId,
          UserAddress: this.selectedUserAddress,
          DeliveryMethod: this.selectedDeliveryMethod
        }
      });
      let addressWasSelected = false;
      chooserOptions.onChoose = (userAddress: any) => {
        if (userAddress !== undefined) {
          addressWasSelected = true;
          this.selectedUserAddress = userAddress;
          if (!userAddress && previousAddress) {
            this.selectedDeliveryMethod = undefined;
          }
        }
      };
      chooseAddressComponent.componentInstance.chooserOptions = chooserOptions;
      chooseAddressComponent.afterClosed().subscribe(() => {
      });
    }
  }

  openChangeSpaceClicked() {
    let chooserOptions = new ChooserOptions();
    const previousSpace = this.selectedSpace;
    let chooseAddressComponent = this.matDialog.open(ChooserComponent, {
      width: '1284px',
      height: '60%',
      data: {
        chooserType: 'SPACE',
        Space: this.selectedSpace
      }
    });
    let spaceWasSelected = false;
    chooserOptions.onChoose = (space: any) => {
      if (space !== undefined) {
        spaceWasSelected = true;
        this.selectedSpace = space;
        if (!space && previousSpace) {
          this.selectedDeliveryMethod = undefined;
        }
      }
    };
    chooseAddressComponent.componentInstance.chooserOptions = chooserOptions;
    chooseAddressComponent.afterClosed().subscribe(() => {
    });
  }

  onRegisterOrderClicked() {
    this.serviceApi.createFactor({
      DeliveryMethodId: this.selectedDeliveryMethod.DeliveryMethodId,
      UserAddressId: this.selectedUserAddress ? this.selectedUserAddress.UserAddressId : undefined,
      SpaceId: this.selectedSpace ? this.selectedSpace.SpaceId : undefined,
      PaymentMethodId: this.selectedPaymentType.PaymentMethodId,
      BranchId: Config.branch.BusinessId
    }).subscribe((res: DataResponse<any>) => {
      if (res.success) {
        if (res.message === 'food-shop-20003') {
          if (res.data.PSP === 'MELAT') {
            this.redirectPost(res.data.Url, res.data.body);
          } else {
            window.location.href = res.data.Url;
          }
        } else {
          if (this.selectedPaymentType.Type === 'CARD_TO_CARD') {
            this.router.navigate([RouteUtil.CLIENT_MODULE, RouteUtil.PAYMENT_DETAIL_COMPONENT, Config.branch.UniqueIdentifier, {
              FactorId: res.data.FactorId
            }]).then();
          } else {
            this.router.navigate([RouteUtil.CLIENT_MODULE, RouteUtil.ORDERS_COMPONENT, Config.branch.UniqueIdentifier]).then();
          }
        }
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  redirectPost(url: string, data: any) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = url;
    Object.keys(data).forEach(key => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = data[key];
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  }
}
